module.exports = {
  "country": "HU",
  "artist": "Kati Wolff",
  "song": "What About My Dreams",
  "year": "2011",
  "place": "22",
  "spotify": "4coje85K8iSAup8z4G9y64"
};